import styled from 'styled-components';

interface ActionMenuItemProps {
	children: React.ReactNode;
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	isDisabled?: boolean;
}

const StyledButton = styled.button<{ $isDisabled?: boolean }>`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0.5rem 1rem;
	background: none;
	border: none;
	text-align: left;
	font-size: inherit;
	cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
	color: inherit;

	&:hover {
		background-color: ${({ $isDisabled }) =>
			$isDisabled ? 'transparent' : 'rgba(0, 0, 0, 0.06)'};
	}
`;

function ActionMenuItem({
	children,
	onClick,
	isDisabled = false,
}: ActionMenuItemProps) {
	return (
		<StyledButton $isDisabled={isDisabled} onClick={onClick}>
			{children}
		</StyledButton>
	);
}

export default ActionMenuItem;
